module.exports = __webpack_public_path__ + "img/project_5.44f0cfb5.jpg";